import React from 'react';
import { Row, Col, Space, Tag, Button } from 'antd';

type FilterOption = { value: string; label: string };

interface FilterOptions {
  nations: FilterOption[];
  payment_statuses: FilterOption[];
  applicant_names: FilterOption[];
  channels: FilterOption[];
  sources: FilterOption[];
  statuses: FilterOption[];
}

interface FiltersState {
  nation: string;
  payment_status: string;
  applicant_name: string;
  channel: string;
  source: string;
  status: string;
  date_field: string;
  date_from: string;
  date_to: string;
}

interface FilterSummaryProps {
  searchText: string;
  searchField: string;
  searchFieldOptions: FilterOption[];
  onClearSearch: () => void;
  onClearSearchField: () => void;
  filters: FiltersState;
  filterOptions: FilterOptions;
  onClearFilter: (key: keyof FiltersState) => void;
  onResetAll: () => void;
}

const FilterSummary: React.FC<FilterSummaryProps> = ({
  searchText,
  searchField,
  searchFieldOptions,
  onClearSearch,
  onClearSearchField,
  filters,
  filterOptions,
  onClearFilter,
  onResetAll,
}) => {
  const hasFilters = Boolean(searchText || searchField !== 'all' || Object.values(filters).some(Boolean));
  const searchFieldLabel = searchFieldOptions.find(opt => opt.value === searchField)?.label;
  if (!hasFilters) return null;
  return (
    <Row style={{ marginBottom: 16 }}>
      <Col span={24}>
        <div style={{ padding: '8px 12px', backgroundColor: '#f0f2f5', borderRadius: '6px', fontSize: '14px', color: '#666' }}>
          <Space wrap>
            <span>已应用筛选条件：</span>
            {searchField !== 'all' && (
              <Tag closable onClose={onClearSearchField}>
                搜索字段: {searchFieldLabel || searchField}
              </Tag>
            )}
            {searchText && (
              <Tag closable onClose={onClearSearch}>搜索: {searchText}</Tag>
            )}
            {filters.nation && (
              <Tag closable onClose={() => onClearFilter('nation')}>
                国家: {filterOptions.nations.find(opt => opt.value === filters.nation)?.label || filters.nation}
              </Tag>
            )}
            {filters.payment_status && (
              <Tag closable onClose={() => onClearFilter('payment_status')}>
                付款状态: {filterOptions.payment_statuses.find(opt => opt.value === filters.payment_status)?.label || filters.payment_status}
              </Tag>
            )}
            {filters.applicant_name && (
              <Tag closable onClose={() => onClearFilter('applicant_name')}>
                申请人: {filterOptions.applicant_names.find(opt => opt.value === filters.applicant_name)?.label || filters.applicant_name}
              </Tag>
            )}
            {filters.channel && (
              <Tag closable onClose={() => onClearFilter('channel')}>
                渠道: {filterOptions.channels.find(opt => opt.value === filters.channel)?.label || filters.channel}
              </Tag>
            )}
            {filters.source && (
              <Tag closable onClose={() => onClearFilter('source')}>
                来源: {filterOptions.sources.find(opt => opt.value === filters.source)?.label || filters.source}
              </Tag>
            )}
            {filters.status && (
              <Tag closable onClose={() => onClearFilter('status')}>
                状态: {filterOptions.statuses.find(opt => opt.value === filters.status)?.label || filters.status}
              </Tag>
            )}
            {(filters.date_field && (filters.date_from || filters.date_to)) && (
              <Tag closable onClose={() => { onClearFilter('date_field'); onClearFilter('date_from'); onClearFilter('date_to'); }}>
                {(() => {
                  const map: Record<string, string> = {
                    payment_at: '付款日期',
                    approve_at: '注册日期',
                    announcement_at: '公告日期',
                    decline_at: '驳回日期',
                    receipt_at: '回执日期',
                  };
                  const label = map[filters.date_field] || filters.date_field;
                  return `${label}: ${filters.date_from || ''}${filters.date_to ? ' ~ ' + filters.date_to : ''}`;
                })()}
              </Tag>
            )}
            <Button type="link" size="small" onClick={onResetAll}>
              清除所有筛选
            </Button>
          </Space>
        </div>
      </Col>
    </Row>
  );
};

export default FilterSummary;
